var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0008 15.2167L4.12295 18.5068L5.43573 11.8999L0.490234 7.3265L7.17943 6.53338L10.0008 0.416667L12.8222 6.53338L19.5113 7.3265L14.5659 11.8999L15.8787 18.5068L10.0008 15.2167ZM10.0008 13.3067L13.5397 15.2876L12.7493 11.3098L15.7269 8.55617L11.6995 8.07862L10.0008 4.39585L8.30211 8.07862L4.27467 8.55617L7.25225 11.3098L6.46185 15.2876L10.0008 13.3067Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLine);
export default __webpack_public_path__ + "static/media/star-line.5b717c1e8ac9736654b65aa389767137.svg";
export { ForwardRef as ReactComponent };